import { useBreakpoint } from 'shared/lib';
import { ViewerMenuMenu } from './viewer-menu-menu';
import { ViewerMenuModal } from './viewer-menu-modal';

export const ViewerMenu = () => {
	const lg = useBreakpoint('lg');

	return lg ? <ViewerMenuMenu /> : <ViewerMenuModal />;
};
